import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss'],
  standalone: false,
})
export class AboutUsComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<AboutUsComponent>) { }

  ngOnInit() {
  }
  
  cancel(){
    this.dialogRef.close();
  }
}
